import { Component, EventEmitter, Input, Output } from '@angular/core';
import { InputInputEventDetail, IonInputCustomEvent } from '@ionic/core';

@Component({
  selector: 'getm-quantity-selector',
  templateUrl: './quantity-selector.component.html',
  styleUrls: ['./quantity-selector.component.scss'],
})
export class QuantitySelectorComponent {

  @Input() quantity: number = 0;
  @Input() minimo: number = 0;
  @Input() maximo: number = 0;
  @Input() color: string = 'getm-primary-default';
  @Input() fill: 'solid' | 'outline' = 'outline';
  @Input() showRemoveBtn: boolean = false;

  @Output() quantityChange = new EventEmitter<number>();
  @Output() removeProduct = new EventEmitter<void>();

  constructor() { }

  public onIncrease = () => {
    if (this.quantity <= this.maximo) {
      this.quantity++;
      this.quantityChange.emit(this.quantity);
    }
  }

  public onDecrease = () => {
    if (this.quantity > this.minimo) {
      this.quantity--;
      this.quantityChange.emit(this.quantity);
    } else if (this.quantity <= this.minimo) {
      this.removeProduct.emit();
    }
  }

  public onInputChange = (event: IonInputCustomEvent<InputInputEventDetail>) => {
    const value = Number(event.target.value);
    if (!isNaN(value) && value >= this.minimo && value <= this.maximo) {
      this.quantity = value;
      this.quantityChange.emit(this.quantity);
    }
  }

  public onRemove = () => this.removeProduct.emit();
}
